import Header from '@/components/common/Header.vue';
import { defineComponent } from 'vue';
import omoListItem from '@/components/list/omoListItem.vue';
import { meetReq } from '@/api/index';
import utils from '@/public/utils/index';
import { getUserId } from '@/widget';
// import BScroll from '@/components/common/BScroll.vue'
import Empty from '@/components/common/Empty.vue';
import { getMoreList } from '@/api/home';
export default defineComponent({
    data() {
        return {
            title: 'OMO训练营',
            list: [],
            pageNo: 1,
            isMine: false,
            pageCount: 1,
            isOperation: 2,
            isComing: true,
            flag: true,
            scroll: false,
            isApp: utils.isApp(),
            keyword: '',
            totalCount: 0,
            typeList: [],
            typeId: 0
        };
    },
    methods: {
        // 切换往期、即将
        changeTab(bl) {
            if (this.flag) {
                this.isComing = bl;
                this.pageNo = 1;
                this.list = [];
                this.typeList = [];
                this.typeId = 0;
                this.getTypeList();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        // 切换类别
        changeType(typeId) {
            if (this.flag) {
                this.typeId = typeId;
                this.pageNo = 1;
                this.list = [];
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        // 切换仅显示我报名的
        changeIsMine() {
            if (this.flag) {
                this.isMine = !this.isMine;
                this.pageNo = 1;
                this.list = [];
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        getTypeList() {
            meetReq
                .getTypeList({
                params: { userId: utils.getUserId() },
                query: {
                    isOperation: this.isOperation,
                    isComing: this.isComing
                }
            })
                .then(res => {
                if (res.code === 200) {
                    this.typeList = res.data;
                }
                else {
                    this.$toast(res.message);
                }
                this.flag = true;
            })
                .catch(() => {
                this.$toast('请求失败，请刷新页面试试');
            });
        },
        getList() {
            if (!this.flag) {
                return;
            }
            this.flag = false;
            if (this.keyword) {
                getMoreList({
                    type: 'omoOperation',
                    pageNo: this.pageNo,
                    userId: getUserId()
                }, {
                    kw: this.keyword,
                    pageNo: this.pageNo
                }).then(res => {
                    if (res.code === 200) {
                        // 未加载完成可以继续加载
                        this.pageCount = res.data.pageCount;
                        // 是否需要上拉加载
                        if (this.pageCount > 1) {
                            this.scrollToBottom();
                        }
                        if (this.pageNo === 1) {
                            this.list = res.data.list;
                        }
                        else {
                            this.list = this.list.concat(res.data.list);
                        }
                    }
                    else {
                        this.$toast(res.message);
                    }
                    this.flag = true;
                });
                return;
            }
            meetReq
                .getMeetingList({
                params: { userId: utils.getUserId() },
                query: {
                    pageNo: this.pageNo,
                    isMine: this.isMine,
                    isOperation: this.isOperation,
                    isComing: this.isComing,
                    typeId: this.typeId
                }
            })
                .then(res => {
                if (res.code === 200) {
                    // 未加载完成可以继续加载
                    this.pageCount = res.data.pageCount;
                    // 是否需要上拉加载
                    if (this.pageCount > 1) {
                        this.scrollToBottom();
                    }
                    if (this.pageNo === 1) {
                        this.list = res.data.list;
                    }
                    else {
                        this.list = this.list.concat(res.data.list);
                    }
                    this.totalCount = res.data.totalCount;
                }
                else {
                    this.$toast(res.message);
                }
                this.flag = true;
            })
                .catch(() => {
                this.$toast('请求失败，请刷新页面试试');
            });
        },
        // 页面触底判断
        scrollToBottom() {
            document.addEventListener('scroll', this.requestMore, false);
        },
        requestMore() {
            var scrollHigh = document.documentElement.scrollTop || document.body.scrollTop;
            // 距离底部200px时触发
            if (scrollHigh + window.innerHeight >= document.body.clientHeight - 200) {
                this.scrollCallBack();
            }
        },
        scrollCallBack() {
            if (this.pageCount > this.pageNo && this.flag) {
                this.pageNo = this.pageNo + 1;
                this.getList();
            }
        }
    },
    created() {
        this.keyword = this.$route.query.keyword || '';
    },
    mounted() {
        this.getTypeList();
        this.getList();
    },
    unmounted() {
        document.removeEventListener('scroll', this.requestMore, false);
    },
    components: {
        Header,
        omoListItem,
        Empty
    }
});
